import { render, staticRenderFns } from "./techHome.vue?vue&type=template&id=550eddb4&scoped=true"
import script from "./techHome.vue?vue&type=script&lang=js"
export * from "./techHome.vue?vue&type=script&lang=js"
import style0 from "./techHome.vue?vue&type=style&index=0&id=550eddb4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550eddb4",
  null
  
)

export default component.exports